module.exports = __webpack_public_path__ + "static/media/icon-equipe-red.435d9f45.svg";